<template>
  <div
    class="live-data-page"
    :class="{
      'electron-live-data-page': isElectron,
      'app-live-data-page': isHXApp,
      'pad-app-data-page': isMGAppInPad,
    }"
  >
    <div v-if="!isHXApp && !isElectron" class="page-header">
      <button @click="$router.push('/')" class="back-btn" v-preventReClick>
        <img src="../../assets/images/arrow-left.png" alt="" />
        返回首页
      </button>
      <span>直播数据</span>
    </div>
    <div class="page-content">
      <LessonInfo class="lesson-info" :liveReport="liveReport"></LessonInfo>
      <ClassStatistics
        class="class-statistics other"
        :liveReport="liveReport"
      ></ClassStatistics>
      <StudentRanking
        class="student-ranking other"
        :liveReport="liveReport"
      ></StudentRanking>
      <ClickerData
        v-if="
          liveReport.question_static_data &&
          liveReport.question_static_data.total_num > 0
        "
        class="clicker-data other"
        :liveReport="liveReport"
      ></ClickerData>
      <LiveIncome
        class="live-income other"
        :liveReport="liveReport"
      ></LiveIncome>
    </div>
  </div>
</template>

<script>
import { isH5, isMGAppInPad, isHXApp } from "@saas/components/src";
import moment from "moment";
import { getLiveReport } from "@saas/service-api/src/course";

import LessonInfo from "./components/LessonInfo.vue";
import ClassStatistics from "./components/ClassStatistics.vue";
import ClickerData from "./components/ClickerData.vue";
import LiveIncome from "./components/LiveIncome.vue";
import StudentRanking from "./components/StudentRanking.vue";
export default {
  components: {
    LessonInfo,
    ClassStatistics,
    ClickerData,
    LiveIncome,
    StudentRanking,
  },
  data: function () {
    return {
      liveReport: {},
      moment,
      showPageCont: true,
      isElectron: window.isElectron,
      isHXApp: isHXApp(),
      isH5: isH5(),
      isMGAppInPad: isMGAppInPad(),
    };
  },
  mounted() {
    this.apiGetLiveReport();
  },
  computed: {},
  methods: {
    apiGetLiveReport() {
      let params = {
        lesson_id: this.$route.params.lesson_id,
      };
      getLiveReport(params).then((res) => {
        if (res.code === 1) {
          this.liveReport = this.handleLiveData(res.data || {});
          // this.setOptions();
        } else {
          this.showPageCont = false;
          this.$message.error(res.message);
        }
      });
    },
    handleLiveData(data) {
      // 排序
      data.live_num_statistics_list.sort((a, b) => {
        return a.date - b.date;
      });
      // 一分钟内的-取最后一个数据
      let dataList = [];
      data.live_num_statistics_list.forEach((item) => {
        item.time = moment(item.date * 1000).format("HH:mm");
        let index = dataList.findIndex((dataItem) => {
          return dataItem.time === item.time;
        });
        dataList.push({ ...item });
        // if (index === -1) {
        //   dataList.push({ ...item });
        // } else {
        //   dataList[index] = { ...item };
        // }
      });
      data.live_num_statistics_list = dataList;
      return data;
    },
  },
};
</script>

<style lang="scss" scoped>
$page-header-height: 70px;
.live-data-page.electron-live-data-page {
  padding-top: 0;
  .page-header {
    top: $nav-height;
    padding: 0;
  }
  .page-content {
    padding: 0;
    padding-bottom: 24px;
  }
}
.live-data-page {
  --live-data-page-bg: var(--mg-bg-page);
  --live-data-header-bg: var(--mg-bg-card);
  --live-data-card-bg: var(--mg-bg-card);
  --live-data-surface-bg: var(--mg-bg-surface);
  --live-data-primary: var(--mg-text-primary);
  --live-data-secondary: var(--mg-text-secondary);
  --live-data-muted: var(--mg-text-muted);
  --live-data-border: var(--mg-border-subtle);
  --live-data-divider: var(--mg-border-subtle);

  min-height: 100vh;
  padding-top: $page-header-height;
  background: var(--live-data-page-bg);
  color: var(--live-data-primary);
  .page-header {
    z-index: 9;
    width: 100%;
    position: fixed;
    top: 0;
    height: $page-header-height;
    background: var(--live-data-header-bg);
    display: flex;
    align-items: center;
    padding: 0 56px;
    justify-content: center;
    font-weight: 600;
    font-size: 16px;
    color: var(--live-data-primary);
    line-height: 22px;
    .back-btn {
      position: absolute;
      left: 56px;
      display: flex;
      align-items: center;
      font-weight: 400;
      font-size: 16px;
      color: var(--live-data-secondary);
      line-height: 22px;
      img {
        width: 9px;
        margin-right: 12px;
      }
    }
  }
  .page-content {
    width: 1200px;
    margin: 0 auto;
    padding: 24px 0;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    .lesson-info {
      width: 100%;
      flex: 1;
    }
    .other {
      width: 49%;
      margin-top: 20px;
    }
    .class-statistics,
    .clicker-data {
      margin-right: 20px;
    }
    ::v-deep .el-dialog {
      top: 50%;
      transform: translateY(-50%);
      margin-top: 0 !important;
    }

    ::v-deep {
      .comp-container,
      .student-dialog,
      .clicker-data-dialog {
        background: var(--live-data-card-bg);
        border: 1px solid var(--live-data-border);
        color: var(--live-data-primary);
      }

      .student-dialog {
        .el-dialog__header {
          background: var(--live-data-card-bg);
          color: var(--live-data-primary);
        }

        .el-dialog__body {
          color: var(--live-data-primary);
        }
      }

      .clicker-data-dialog {
        .el-dialog__header,
        .el-dialog__body {
          background: var(--live-data-card-bg);
          color: var(--live-data-primary);
        }
      }

      .title p,
      .data,
      .num,
      .percent,
      .student-name,
      .data-cell,
      .section-title,
      .info-value,
      .row-cell,
      .course-name,
      .current-page,
      .total-pages {
        color: var(--live-data-primary);
      }

      .data-name,
      .label,
      .more-btn,
      .more-btn i,
      .tips,
      .header-cell,
      .info-label,
      .dialog-tip,
      .separator {
        color: var(--live-data-secondary);
      }

      .right .item,
      .student-table-row,
      .table-header,
      .stats-info,
      .answer-table,
      .detail-table,
      .student-stats-section,
      .answer-stats-section,
      .pagination-btn,
      .pagination-info,
      .info-item,
      .tab-container,
      .tab-item {
        background: var(--live-data-surface-bg);
        border-color: var(--live-data-border);
      }

      .tab-item.active {
        background: var(--mg-brand-soft-bg);
        color: var(--mg-brand-primary);
      }

      .data-item::after,
      .divider,
      hr {
        background: var(--live-data-divider);
        border-color: var(--live-data-divider);
      }

      .pagination-btn:disabled {
        background: var(--live-data-surface-bg);
        opacity: 0.5;
      }
    }
  }
}

.live-data-page {
  html.dark & {
    --live-data-page-bg: var(--mg-bg-page);
    --live-data-header-bg: var(--mg-bg-card);
    --live-data-card-bg: var(--mg-bg-surface);
    --live-data-surface-bg: var(--mg-bg-elevated);
    --live-data-primary: var(--mg-text-primary);
    --live-data-secondary: var(--mg-text-secondary);
    --live-data-muted: var(--mg-text-muted);
    --live-data-border: var(--mg-border-subtle);
    --live-data-divider: var(--mg-border-subtle);
    --live-data-divider-strong: var(--mg-border-subtle);
  }
}
//app
.live-data-page.app-live-data-page {
  padding-top: 0;
}
.live-data-page.pad-app-data-page {
  .page-content {
    width: 600px;
    display: flex;
    flex-direction: column;
    .other {
      width: 100%;
      margin-top: 20px;
      margin-right: 0;
    }
  }
}
</style>
